import { useQueryClient } from '@tanstack/react-query';
import { BillingTableItem } from './types';
import { debitMemoBillingItemsQueryKey, invoiceBillingItemsQueryKey } from './useBillingQueries';

const keyMap: Record<BillingTableItem['itemType'], string> = {
  debitMemo: debitMemoBillingItemsQueryKey,
  invoice: invoiceBillingItemsQueryKey,
};

export const useUpdateBillingItemQuery = () => {
  const client = useQueryClient();

  return (billingTableItem: BillingTableItem) => {
    const key = keyMap[billingTableItem.itemType];

    return client.setQueryData<BillingTableItem[]>([key], (current = []) => {
      return current.map((i) => (i.Id === billingTableItem.Id ? billingTableItem : i));
    });
  };
};
